export const DEFAULT_READING_LIST = 'bookmarks';
